import React from 'react';
import { styled, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';

const StyledTextField = styled(TextField)(() => ({
  backgroundColor: '#F5F6FA',
  '& .MuiOutlinedInput-root': {
    color: '#8991A7',
    '& fieldset': {
      border: '1px solid #D5D5D5',
      borderRadius: '5px',
    },
    '&:hover fieldset': {
      border: '1px solid #D5D5D5',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #D5D5D5',
    },
  },
}));

const CustomTextField = ({
  label,
  name,
  formik,
  placeholder,
  sx = {},
  size,
  rows,
  multiline,
  minRows = 1, // Minimum row count
  maxRows = 6, // Maximum row count
}) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

  const textFieldSize = size || (isMediumScreen ? 'small' : 'large');

  return (
    <>
      <Typography variant="body1" sx={{ color: '#ADADAD', mt: { lg: 3, xs: 2 } }} >{label}</Typography>
      <StyledTextField
        sx={{ mt: 1 }}
        fullWidth
        multiline={multiline}
        minRows={multiline ? minRows : undefined}
        maxRows={multiline ? maxRows : undefined}
        variant={'outlined'}
        placeholder={placeholder}
        size={textFieldSize}
        name={name}
        value={formik.values[name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched[name] && Boolean(formik.errors[name])}
      />
      {formik.touched[name] && formik.errors[name] && (
        <Typography color="error" variant='body2' mt={1}>{formik.errors[name]}</Typography>
      )}
    </>
  );
};

export default CustomTextField;